export const ICONS_ID = 'icons-root';
